import React from 'react';
import PropTypes from 'prop-types';
import defer from 'lodash/defer';
import { Link } from '@resy/ui-kitchen';
import { sanitizeString } from '../../../../../../ui-kitchen/src/utils/sanitizeString';
import { setLocationPath } from '../../../../../../ui-kitchen/src/utils/locationUtils';
import './DeltaWifiFooter.scss';
import ResyLogo from '../../../../images/resy-logo-red.svg';
import { getResyCopyright, handleMktAnalytics } from '../../AmexMarketingUtils/AmexUtils';
import { CTA_EVENT_NAME } from '../../AmexMarketingUtils/constants';

const DeltaWifiFooter = (
  {
    isAuthenticated, footerConfig, analyticsEvent, $rootScope,
  }
) => {
  const links = footerConfig?.links;
  const copyright = footerConfig?.copyright;
  const footerData = isAuthenticated ? footerConfig?.loggedIn : footerConfig?.loggedOut;
  const {
    heading,
    content,
    visitLinkText,
  } = footerData;

  const handleFooterTag = (e, hrefValue, extraParams) => {
    e.preventDefault();
    handleMktAnalytics(analyticsEvent, CTA_EVENT_NAME, extraParams);
    setLocationPath(hrefValue, () => defer(() => $rootScope.$apply()));
    window.location.href = hrefValue;
  };

  const renderCopyright = () => {
    const sanitizedResyCopyright = sanitizeString(getResyCopyright(copyright));
    return (
      <p
        className="DeltaWifiFooter__nav--copy"
        dangerouslySetInnerHTML={{ // eslint-disable-line react/no-danger
          __html: sanitizedResyCopyright,
        }}
      />
    );
  };

  return (
    <section className="DeltaWifiFooter">
      <div className="container DeltaWifiFooter__visitResy">
        <div className="row">
          <div className="col-md-8 offset-md-2">
            <Link
              className="DeltaWifiFooter__visitResy--linkLogo"
              aria-label={visitLinkText}
              onClick={(e) => handleFooterTag(e, '/', { action_name: 'Footer - Resy Logo Click' })}
            >
              <ResyLogo
                className="DeltaWifiFooter__visitResy--logo"
                aria-hidden="true"
              />
            </Link>
            <h2 className="DeltaWifiFooter__visitResy--heading">{heading}</h2>
            <p className="DeltaWifiFooter__visitResy--content">
              {content}
            </p>
            <p>
              <Link
                className="DeltaWifiFooter__visitResy--link"
                onClick={(e) => handleFooterTag(e, '/', { action_name: 'Footer - Go to Resy Click' })}
              >
                {visitLinkText}
              </Link>
            </p>
          </div>
        </div>
      </div>
      <div className="container DeltaWifiFooter__nav">
        <div className="DeltaWifiFooter__nav--wrapper">
          {renderCopyright()}
          <nav aria-label="Footer navigation">
            <ul>
              {links.map((link) => (
                <li>
                  <Link
                    className="DeltaWifiFooter__nav--link"
                    onClick={(event) => {
                      const extraParams = { action_name: 'Footer - Link Click', item_name: link.label };
                      handleFooterTag(event, link.url, extraParams);
                    }}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </div>
    </section>
  );
};

DeltaWifiFooter.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired,
  footerConfig: PropTypes.shape({
    links: PropTypes.arrayOf(PropTypes.shape()),
    copyright: PropTypes.string.isRequired,
    loggedIn: PropTypes.shape({}),
    loggedOut: PropTypes.shape({}),
  }).isRequired,
  analyticsEvent: PropTypes.func.isRequired,
  $rootScope: PropTypes.shape({
    $apply: PropTypes.func,
  }).isRequired,
};

export default DeltaWifiFooter;
